// extracted by mini-css-extract-plugin
export default {"list":"TodoList_list__dqQoz"};